<template>
    <b-modal
        id="module-rubric-add-rubric"
        modal-class="apprentice-default-modal"
        :title="$t('modules.select_rubric')"
        size="md"
        ok-only
        :ok-title="$t('common.close')">
        <div class="survey-choose-rubric">
            <h4 class="title">{{ $t('modules.choose_rubric') }}</h4>
            <div class="rubrics">
                <div class="rubric-skill-sets">
                    <b-form-group
                        class="rubric-skill-sets-group"
                        :label="$t('modules.choose_set_of_skills')"
                        label-for="rubric-skill-sets-select">
                        <design-2021-apprentice-multiselect-component
                            id="rubric-skill-sets-select"
                            v-model="selectedSkillTree"
                            :multiple-select="false"
                            label="name"
                            :options="skillTreesIn"
                            @input="setSkillTree($event)"
                            :show-labels="false">
                        </design-2021-apprentice-multiselect-component>
                    </b-form-group>
                </div>

                <div class="rubric-skill">
                    <b-form-group
                        class="rubric-skill-group"
                        :label="$t('modules.choose_skill')"
                        label-for="rubric-skill-select">
                        <design-2021-apprentice-multiselect-component
                            id="rubric-skill-select"
                            v-model="selectedSkill"
                            :multiple-select="false"
                            label="name"
                            :options="skills"
                            @input="setSkill($event)"
                            :show-labels="false"
                            :disabled="selectedSkillTree === null">
                        </design-2021-apprentice-multiselect-component>
                    </b-form-group>
                </div>

                <div class="rubric">
                    <b-form-group
                        class="rubric-group"
                        :label="$t('modules.choose_rubric')"
                        label-for="rubric-select">
                        <design-2021-apprentice-multiselect-component
                            id="rubric-select"
                            v-model="selectedRubric"
                            label="title"
                            :multiple-select="false"
                            :options="rubrics"
                            :show-labels="false"
                            :disabled="selectedSkill === null">
                        </design-2021-apprentice-multiselect-component>
                    </b-form-group>
                </div>
            </div>

            <b-button
                class="btn-add btn-add-survey"
                variant="primary"
                @click="addRubric()">
                {{ $t('modules.add_rubric') }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-module-management-edit-survey-add-modal-select-rubric',
    props: {
        skillTreesIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            selectedSkillTree: null,
            selectedSkill: null,
            selectedRubric: null,
            rubrics: [],
            skills: [],
            rubricData: [],
        };
    },

    methods: {
        onOk() {},

        setSkillTree(event) {
            if (!event) {
                return;
            }

            this.selectedSkillTree = event;

            this.skills = event.skill_skill_trees.map((item) => {
                return item.skill;
            });

            this.rubrics = [];
            this.selectedSkill = null;
            this.selectedRubric = null;
        },

        setSkill(event) {
            if (!event) {
                return;
            }

            this.selectedSkill = event;
            this.selectedRubric = null;

            for (const tree of this.selectedSkillTree.skill_skill_trees) {
                if (tree.skill_id === event.id) {
                    this.rubrics = tree.rubrics;
                }
            }
        },

        addRubric() {
            const rubric = {
                skillTree: this.selectedSkillTree,
                skill: this.selectedSkill,
                rubric: this.selectedRubric,
            };

            this.$emit('add-rubric', rubric);

            this.selectedSkill = null;
            this.selectedSkillTree = null;
            this.selectedRubric = null;
        },
    },
};
</script>

<style scoped lang="scss"></style>
